import { render, staticRenderFns } from "./CreateNotification.vue?vue&type=template&id=152daf6a"
import script from "./CreateNotification.vue?vue&type=script&lang=js"
export * from "./CreateNotification.vue?vue&type=script&lang=js"
import style0 from "./CreateNotification.vue?vue&type=style&index=0&id=152daf6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports